// extracted by mini-css-extract-plugin
export default {"heroSection":"Home_heroSection__sJR00","homePageSections":"Home_homePageSections__Yvfhw"};